import { createAsyncAction } from "typesafe-actions";
import TopUpEWalletRequest from "../../models/eWallet/TopUpEWalletRequest";
import { TopUpEWalletActionTypes } from "./types";

export const topUpEWalletActions = createAsyncAction(
    TopUpEWalletActionTypes.REQUEST,
    TopUpEWalletActionTypes.SUCCESS,
    TopUpEWalletActionTypes.ERROR
)<TopUpEWalletRequest, any, any>();
